export enum EActivityTagName {
  IMG = 'img',
  A = 'a',
}
